module.exports = __webpack_public_path__ + "media/images/language_switcher/de-1708c5f78a40e2382860bd1a6fc03353.svg";